Namespace 'Common.Dashboard.Filters'

class Common.Dashboard.Filters.FiltersFactory

  _getFilterData: (filterType) ->
    filterData = @_filters[filterType]
    throw new Error("Unknown type #{filterType}") unless filterData
    filterData

  getUnappliedView: (filter) =>
    @_getFilterData(filter.getFilterType()).unapplied(filter)

  getAppliedView: (filter) =>
    @_getFilterData(filter.getFilterType()).applied(filter)

  getFilter: (filterType, contents) =>
    @_getFilterData(filterType).filter(contents)

  getFilterTypes: =>
    Object.keys(@_filters)

